module.exports = __webpack_public_path__ + "static/media/Hero1.1deac9e5.jpg";